module.exports = __webpack_public_path__ + "assets/normal/images/ai_loading.a2a42b5e.png";